// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal__backdrop___1ucLR","container":"modal__container___1NVNB","close":"modal__close___7iXW0"};